// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toc-wide-variant":"_3mDuhj","bottom":"_2Vgmw-","hideDesktop":"_2xxrdp","hideNotDesktop":"_3KKFy_","stickyBox":"_3HCVxT"};